<template>
	<div class="block-quote" v-if="block.content">
		<div>
			<p v-html="block.content.text"></p>
			<p v-html="block.content.citation"></p>
		</div>
	</div>
</template>

<script>


import scrollBehavior  from '@/mixins/scrollBehavior.js'
import loaderHandler  from '@/mixins/loaderHandler.js'

export default {
	props: ['block','currentLang'],
	mixins: [scrollBehavior, loaderHandler],
}
</script>

<style lang="scss">
	.block-quote{
		max-width:850px;
		margin:auto;
		padding:5%;
		position:relative;
		> div{
			border-left: 1px solid #000;
			padding:0 5%;
			line-height:1.3;
			> p:first-child{
				font-style:italic;
				font-size: 1.333em;
				margin-bottom:.6em;
			}
		}
	}
</style>